import { render, staticRenderFns } from "./LeaveMassageAdd.vue?vue&type=template&id=3be36c8e&scoped=true&"
import script from "./LeaveMassageAdd.vue?vue&type=script&lang=js&"
export * from "./LeaveMassageAdd.vue?vue&type=script&lang=js&"
import style0 from "./LeaveMassageAdd.vue?vue&type=style&index=0&id=3be36c8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be36c8e",
  null
  
)

export default component.exports